import { createRoot, hydrateRoot } from "react-dom/client";

import { HelmetProvider } from "react-helmet-async";

import App from "./App";

import { AppProviders } from "./app-providers";

import { SsrBlogProvider } from "./contexts/SsrBlogContext";

import { SsrBlogIndexProvider } from "./contexts/SsrBlogIndexContext";

import type { SsrBlogPost, SsrBlogIndexBootstrap } from "@shared/blogSsr";

import "./index.css";



declare global {

  interface Window {

    __SSR_BLOG_POST__?: Omit<SsrBlogPost, "createdAt"> & { createdAt: string };

    __SSR_BLOG_INDEX__?: SsrBlogIndexBootstrap;

  }

}



function readBootstrapBlogPost(): SsrBlogPost | undefined {

  const raw = window.__SSR_BLOG_POST__;

  if (!raw) return undefined;

  return {

    ...raw,

    createdAt: new Date(raw.createdAt),

  };

}



const analyticsEndpoint = import.meta.env.VITE_ANALYTICS_ENDPOINT;

const analyticsWebsiteId = import.meta.env.VITE_ANALYTICS_WEBSITE_ID;

if (analyticsEndpoint && analyticsWebsiteId) {

  const script = document.createElement("script");

  script.defer = true;

  script.src = `${analyticsEndpoint}/umami`;

  script.dataset.websiteId = analyticsWebsiteId;

  document.body.appendChild(script);

}



const bootstrapPost = readBootstrapBlogPost();

const bootstrapIndex = window.__SSR_BLOG_INDEX__;

const container = document.getElementById("root")!;



const app = (

  <HelmetProvider>

    <AppProviders>

      <SsrBlogProvider post={bootstrapPost}>

        <SsrBlogIndexProvider data={bootstrapIndex}>

          <App />

        </SsrBlogIndexProvider>

      </SsrBlogProvider>

    </AppProviders>

  </HelmetProvider>

);



// Blog pages inject static HTML that does not match the React tree. Hydrating

// would replace the article or post grid with a loading shell until client fetch runs.

if (bootstrapPost || bootstrapIndex) {

  createRoot(container).render(app);

} else {

  hydrateRoot(container, app);

}


